"use client";

import { observer } from "mobx-react";
import styles from "./styles/ShopOfferings.module.scss";
import ShopItem from "./ShopItem";
import FontAwesome from "../../../utilities/FontAwesome";
import { LoadingItemArray } from "./ShopTerrace";
import classNames from "classnames";

const ShopOfferings = observer(
  (props: {
    data?: any[];
    className?: string;
    loadingClassName?: string;
    isLoading?: boolean;
    numItemsLoading?: number;
  }) => {
    const containerClassName = classNames({
      [styles.container]: true,
      [props.className || ""]: props.className,
    });

    return (
      <div className={containerClassName}>
        {props.isLoading ? (
          <LoadingItemArray
            numItems={props.numItemsLoading || 5}
            className={`${styles.loadingArray} ${props.loadingClassName}`}
          />
        ) : (
          <>
            {props.data?.length ? (
              props.data?.slice(0, props.numItemsLoading).map((item, index) => {
                return (
                  <ShopItem key={item.id || `item-${index}`} item={item} />
                );
              })
            ) : (
              <div
                className={styles.shopInfoMessage}
                style={{ color: "darkred" }}
              >
                <FontAwesome
                  ariaHidden={true}
                  prefix={"fas"}
                  name="fa-circle-exclamation"
                />
                {" There was an issue loading this store."}
              </div>
            )}
          </>
        )}
      </div>
    );
  },
);

export default ShopOfferings;
